/* © CNES */
import { ProgressSpinner } from 'primereact/progressspinner';
import { Sidebar } from 'primereact/sidebar';
import { TabPanel, TabView } from 'primereact/tabview';
import { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../../context/ConfigContext';
import { CollectionsForUser } from '../../../models/CollectionsForUser';
import { Filters } from './Filters/Filters';
import './LeftSidePanel.scss';
import { Results } from './Results/Results';

/**
 * LeftSidePanel Props
 */
interface LeftSidePanelProps {
  setFiltersVisibility: Function;
  isDatalakeAvailable: string;
  userCollections: CollectionsForUser;
  setIsDatalakeAvailable: Function;
  setMaxProductsWarningVisible: Function;
}

/**
 * LeftSidePanel displays a Panel on Left side of the screen with filters and Results.
 * @param setFiltersVisibility function setFiltersVisibility.
 * @param userCollections Collections from catalog that user can filter from.
 * @param setIsDatalakeAvailable function setIsDatalakeAvailable.
 * @param isDatalakeAvailable datalake availibility status.
 * @param setMaxProductsWarningVisible function setMaxProductsWarningVisible.
 * @returns LeftSidePanel Element.
 */
export const LeftSidePanel = ({
  setFiltersVisibility,
  userCollections,
  setIsDatalakeAvailable,
  isDatalakeAvailable,
  setMaxProductsWarningVisible,
}: LeftSidePanelProps) => {
  const [showPanel, setShowPanel] = useState(true);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const context = useContext(ConfigContext);

  /**
   * setShowPanel on context change.
   */
  useEffect(() => {
    setShowPanel(context.isLeftSidePanelShown);
  }, [context]);

  return (
    <>
      {showPanel && (
        <Sidebar
          showCloseIcon={false}
          modal={false}
          visible={showPanel}
          dismissable={false}
          onHide={() => setShowPanel(false)}
        >
          <TabView className="mypanel">
            <TabPanel
              headerClassName="leftSideTapPanel"
              header={<div>Filters</div>}
            >
              <Filters
                setIsFetching={setIsFetching}
                setFiltersVisibility={setFiltersVisibility}
                userCollections={userCollections}
              />
            </TabPanel>
            <TabPanel
              headerClassName="leftSideTapPanel"
              header={
                isFetching ? (
                  <div>
                    Results [
                    <ProgressSpinner
                      style={{ width: '18px', height: '18px' }}
                    />
                    ]
                  </div>
                ) : (
                  `Results (${context.featuresCount})`
                )
              }
            >
              <Results
                setFiltersVisibility={setFiltersVisibility}
                setIsDatalakeAvailable={setIsDatalakeAvailable}
                isDatalakeAvailable={isDatalakeAvailable}
                setMaxProductsWarningVisible={setMaxProductsWarningVisible}
              />
            </TabPanel>
          </TabView>
        </Sidebar>
      )}
    </>
  );
};
